export enum DisplayMode {
    None = 0,
    Table = 1,
    Cards = 2,
  }